import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { useCustomFetch } from '@/hooks/useCustomFetch';
import { baseUrl } from '@/utils/constants';

export default function useTestTelemetry() {
  const telemetryTestApiUrl = `${baseUrl}admin/telemetry`;

  const { authResult } = useContext(TokenContext);
  const { customFetchResponse } = useCustomFetch();

  const testTelemetry = useCallback(async () => {
    const response = await customFetchResponse(telemetryTestApiUrl, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authResult.accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Telemetry API call failed with status ${response.status}.`);
    }
  }, [authResult.accessToken, customFetchResponse, telemetryTestApiUrl]);

  return { testTelemetry };
}
